import type { VuetifyOptions } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VFileUpload } from 'vuetify/labs/VFileUpload'

const defaultInputs = {
  variant: 'outlined',
  hideDetails: false,
  color: 'primary',
  density: 'compact',
}

export const commonVuetifyOptions: VuetifyOptions = {
  defaults: {
    VTextField: defaultInputs,
    VSelect: defaultInputs,
    VAutocomplete: defaultInputs,
    VCheckbox: defaultInputs,
    VFileInput: defaultInputs,
    VTextarea: defaultInputs,
    VNumberInput: defaultInputs,
  },
  components: {
    ...components,
    VFileUpload,
  },
  directives,
}
